import React from "react";
import { Tabs, TabsList, TabsTrigger, TabsContent } from "./ui/tabs";
import { WagonDetail } from "./WagonDetail";
import { OcrQueue } from "./OcrQueue";
import { EventJournal } from "./EventJournal";
import { WorkerPanel } from "./WorkerPanel";
import { MousePointerClick, ScanLine, ListOrdered, Info, ClipboardList } from "lucide-react";

export const RightPanel = ({
  selectedWagon,
  t,
  lang,
  events,
  ocr,
  tab,
  setTab,
  onCloseWagon,
  onSave,
  onMove,
  trackOptions,
  onResolveOcr,
  yard,
  onAcceptTrain,
}) => {
  return (
    <aside className="h-full flex flex-col bg-[#0d0d10] border-l border-zinc-800">
      <Tabs value={tab} onValueChange={setTab} className="flex flex-col h-full">
        <TabsList className="grid grid-cols-4 gap-1 m-2 bg-zinc-900 rounded-sm h-auto p-1">
          <TabsTrigger
            value="wagon"
            data-testid="tab-wagon"
            className="text-[10px] gap-1 data-[state=active]:bg-sky-500 data-[state=active]:text-white rounded-sm py-1.5"
          >
            <Info size={12} /> {t("details")}
          </TabsTrigger>
          <TabsTrigger
            value="intake"
            data-testid="tab-intake"
            className="text-[10px] gap-1 data-[state=active]:bg-amber-500 data-[state=active]:text-black rounded-sm py-1.5"
          >
            <ClipboardList size={12} /> {t("intake")}
          </TabsTrigger>
          <TabsTrigger
            value="ocr"
            data-testid="tab-ocr"
            className="text-[10px] gap-1 data-[state=active]:bg-sky-500 data-[state=active]:text-white rounded-sm py-1.5 relative"
          >
            <ScanLine size={12} /> OCR
            {ocr && ocr.length > 0 && (
              <span className="absolute -top-1 -right-1 min-w-4 h-4 px-1 grid place-items-center text-[9px] font-bold rounded-full bg-amber-500 text-black">
                {ocr.length}
              </span>
            )}
          </TabsTrigger>
          <TabsTrigger
            value="journal"
            data-testid="tab-journal"
            className="text-[10px] gap-1 data-[state=active]:bg-sky-500 data-[state=active]:text-white rounded-sm py-1.5"
          >
            <ListOrdered size={12} /> {t("journal")}
          </TabsTrigger>
        </TabsList>

        <div className="flex-1 min-h-0">
          <TabsContent value="wagon" className="h-full m-0">
            {selectedWagon ? (
              <WagonDetail
                wagon={selectedWagon}
                t={t}
                lang={lang}
                onSave={onSave}
                onMove={onMove}
                trackOptions={trackOptions}
                onClose={onCloseWagon}
              />
            ) : (
              <div className="flex flex-col items-center justify-center h-full text-zinc-600 gap-3 p-6 text-center">
                <MousePointerClick size={34} />
                <p className="text-[13px] font-medium text-zinc-400">{t("selectWagon")}</p>
                <p className="text-[11px] text-zinc-600 leading-relaxed">{t("selectWagonHint")}</p>
              </div>
            )}
          </TabsContent>

          <TabsContent value="intake" className="h-full m-0">
            <WorkerPanel yard={yard} t={t} lang={lang} onAcceptTrain={onAcceptTrain} />
          </TabsContent>

          <TabsContent value="ocr" className="h-full m-0">
            <OcrQueue items={ocr} t={t} onResolve={onResolveOcr} editable />
          </TabsContent>

          <TabsContent value="journal" className="h-full m-0">
            <EventJournal events={events} lang={lang} t={t} />
          </TabsContent>
        </div>
      </Tabs>
    </aside>
  );
};
